var map = {
	"./anf-default.svg": 78387,
	"./aws-default.svg": 8133,
	"./azure-default.svg": 98823,
	"./azure_data_lake-default.svg": 18640,
	"./box-default.svg": 79649,
	"./cifs-default.svg": 19627,
	"./cvo-default.svg": 97672,
	"./cvs-default.svg": 27844,
	"./data-broker-default.svg": 28684,
	"./directory-default.svg": 38123,
	"./efs-default.svg": 19838,
	"./file-server-default.svg": 60576,
	"./fsx-default.svg": 27297,
	"./gcp-default.svg": 18380,
	"./gdrive-default.svg": 74071,
	"./ibm-default.svg": 20300,
	"./nfs-default.svg": 16193,
	"./onprem-default.svg": 85669,
	"./ontap-default.svg": 43756,
	"./s3-default.svg": 42664,
	"./sftp-default.svg": 41677,
	"./sgws-default.svg": 50694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78760;